import type { FC } from 'react';

import { Hotkey } from 'config/enums';
import { useAppSelector } from 'features/app/hooks';
import { useCallHearingParticipantHandlers } from 'features/call/call-accepted/hooks';
import { CallDetailsButtonDisconnect } from 'features/call/call-details/components';
import {
  isAnyHearingConnectingSelector,
  primaryHearingSelector,
} from 'features/call/call-hearing/store';

interface CallDetailsButtonHearingDisconnectProps {
  hotkey?: Hotkey;
}

export const CallDetailsButtonHearingDisconnect: FC<
  CallDetailsButtonHearingDisconnectProps
> = ({ hotkey = Hotkey.CalleeConnectionStateChange }) => {
  const { handleHearingDisconnect } = useCallHearingParticipantHandlers();
  const primaryHearing = useAppSelector(primaryHearingSelector);
  const isAnyHearingConnecting = useAppSelector(isAnyHearingConnectingSelector);
  return (
    <CallDetailsButtonDisconnect
      onClick={() => handleHearingDisconnect(primaryHearing.id)}
      hotkey={hotkey}
      disabled={isAnyHearingConnecting}
      buttonType='hearing'
    />
  );
};
